export default __webpack_public_path__ + "static/media/visible.ced99001.svg";